import { capitalizeFirstLetterOnly } from '@/helpers/dataHelper';
import { Empty, Pagination, Skeleton } from 'antd';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { Col } from 'reactstrap';

const RoomsItem = ({ rooms, loading, total, handlePagination }) => {
  const query = useSelector((state: any) => state.roomReducer.query.roomList);
  const generateRandomColor = () => {
    const green = Math.floor(Math.random() * 200);
    const blue = Math.floor(Math.random() * 200);
    return 'rgb(' + 0 + ', ' + green + ', ' + blue + ')';
  };

  return (
    <>
      {loading &&
        [...Array(1, 2, 3, 4)]?.map((i: number) => (
          <Col lg="3" md="12" key={i}>
            <div
              className="room-item border-0 "
              style={{
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px',
                borderRadius: '16px',
              }}
            >
              <div
                className="room-image "
                style={{
                  height: '200px',
                }}
              >
                <Skeleton.Image className="w-100 h-100" />
              </div>
              <div
                className="room-content"
                style={{
                  height: '60px',
                }}
              >
                <div className="content-detail">
                  <Skeleton active />
                </div>
              </div>
            </div>
          </Col>
        ))}
      {rooms?.data?.data?.length === 0 ? (
        <div className="not-found">
          <Empty />
        </div>
      ) : (
        !loading &&
        rooms?.data?.data?.map((data, i) => (
          <div className="col-sm-6 col-md-4 col-lg-3 room-single-item mt-2">
            <Link href={`room/${data.slug}`}>
              <a>
                <div
                  className="card mb-3"
                  style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px' }}
                >
                  {data?.image ? (
                    <img
                      src={`${data.image}`}
                      style={{ height: '200px' }}
                      width={'auto'}
                      alt="card img"
                      className="card-img-top"
                    />
                  ) : (
                    <div
                      className="room-image p-3"
                      style={{
                        background: generateRandomColor(),
                        height: '200px',
                      }}
                    >
                      <h4 className="text-white m-0 d-flex justify-content-center align-items-center h-100">
                        {capitalizeFirstLetterOnly(data?.title)}
                      </h4>
                    </div>
                  )}

                  <div className="card-body">
                    <h5 className="card-title text-dark">{data?.title}</h5>
                    <div className="room-price">
                      <p>
                        <i className="fa fa-users mr-2"></i>
                        {data?.members_count} Members
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </Link>
          </div>
        ))
      )}
      {loading ? (
        <Skeleton.Button className="mt-5 text-center" active />
      ) : (
        rooms?.data?.data?.length !== 0 && (
          <Col md="12">
            <Pagination
              defaultCurrent={query?.page}
              total={total}
              defaultPageSize={query?.per_page}
              onChange={handlePagination}
              className="text-center mt-5"
            />
          </Col>
        )
      )}
    </>
  );
};

export default RoomsItem;
